module.exports = __webpack_public_path__ + "static/media/f4.e39e1ae7.png";